export default "__VITE_ASSET__5fQBD58X__"